var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 943,
    height: 837,
    viewBox: "0 0 943 837",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 443.763,
    y: 706.333,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-30 443.763 706.333)",
    fill: "#89ABE3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 703.57,
    y: 556.333,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-30 703.57 556.333)",
    fill: "#89ABE3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 483.714,
    y: 625.532,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(-30 483.714 625.532)",
    fill: "#89ABE3FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 613.618,
    y: 550.532,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(-30 613.618 550.532)",
    fill: "#89ABE3FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 498.666,
    y: 501.429,
    width: 50,
    height: 200,
    rx: 25,
    transform: "rotate(-30 498.666 501.429)",
    fill: "#89ABE3FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 712.747,
    y: 590.42,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-90 712.747 590.42)",
    fill: "#89ABE3FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 712.747,
    y: 290.42,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-90 712.747 290.42)",
    fill: "#89ABE3FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 662.747,
    y: 515.42,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(-90 662.747 515.42)",
    fill: "#89ABE3FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 662.747,
    y: 365.42,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(-90 662.747 365.42)",
    fill: "#89ABE3FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 562.747,
    y: 440.42,
    width: 50,
    height: 200,
    rx: 25,
    transform: "rotate(-90 562.747 440.42)",
    fill: "#89ABE3FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 746.801,
    y: 299.404,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-150 746.801 299.404)",
    fill: "#89ABE3FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 486.994,
    y: 149.404,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(-150 486.994 149.404)",
    fill: "#89ABE3FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 656.85,
    y: 305.206,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(-150 656.85 305.206)",
    fill: "#89ABE3FF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 526.946,
    y: 230.206,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(-150 526.946 230.206)",
    fill: "#89ABE3FF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 541.898,
    y: 354.308,
    width: 50,
    height: 200,
    rx: 25,
    transform: "rotate(-150 541.898 354.308)",
    fill: "#89ABE3FF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 511.871,
    y: 124.301,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(150 511.871 124.301)",
    fill: "#89ABE3FF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 252.064,
    y: 274.301,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(150 252.064 274.301)",
    fill: "#89ABE3FF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 471.919,
    y: 205.102,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(150 471.919 205.102)",
    fill: "#89ABE3FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 342.016,
    y: 280.102,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(150 342.016 280.102)",
    fill: "#89ABE3FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 456.968,
    y: 329.205,
    width: 50,
    height: 200,
    rx: 25,
    transform: "rotate(150 456.968 329.205)",
    fill: "#89ABE3FF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 243.119,
    y: 240.206,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(90 243.119 240.206)",
    fill: "#89ABE3FF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 243.119,
    y: 540.206,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(90 243.119 540.206)",
    fill: "#89ABE3FF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 293.119,
    y: 315.206,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(90 293.119 315.206)",
    fill: "#89ABE3FF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 293.119,
    y: 465.206,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(90 293.119 465.206)",
    fill: "#89ABE3FF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 393.119,
    y: 390.206,
    width: 50,
    height: 200,
    rx: 25,
    transform: "rotate(90 393.119 390.206)",
    fill: "#89ABE3FF"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 209.064,
    y: 531.221,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(30 209.064 531.221)",
    fill: "#89ABE3FF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 468.872,
    y: 681.221,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(30 468.872 681.221)",
    fill: "#89ABE3FF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 299.016,
    y: 525.42,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(30 299.016 525.42)",
    fill: "#89ABE3FF"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 428.92,
    y: 600.42,
    width: 50,
    height: 100,
    rx: 25,
    transform: "rotate(30 428.92 600.42)",
    fill: "#89ABE3FF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 413.968,
    y: 476.318,
    width: 50,
    height: 200,
    rx: 25,
    transform: "rotate(30 413.968 476.318)",
    fill: "#89ABE3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M815.993 208.537L488.765 18.7467C482.572 15.1547 474.931 15.1471 468.731 18.7269L140.631 208.155C134.433 211.734 130.619 218.352 130.631 225.51L131.271 605.566C131.283 612.713 135.108 619.31 141.304 622.872L469.556 811.568C475.739 815.122 483.347 815.115 489.523 811.549L815.955 623.083C822.143 619.511 825.955 612.908 825.955 605.763L825.959 225.838C825.959 218.707 822.162 212.115 815.993 208.537Z",
    stroke: "#89ABE3FF",
    strokeWidth: 25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2cad46b82f747223f943a6998e9bd875.svg";
export { ForwardRef as ReactComponent };